
const getters = {
  baseParameter: state => state.user.baseParameter,
}
export default getters
